import { UnpaidBillsAction } from "../actions/UnpaidBillsAction";
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initUnpaidBills = {
    requestBody: {
        sectionId: "UnpaidBills",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "UnpaidBills",
                options: [
                    {
                        name: "Customer Bills",
                        value: "true"
                    }
                ],
                fields: [
                    {
                        name: "Bills Amount",
                        value: ""
                    },
                    {
                        name: "Unpaid Bills Response",
                        value: ""
                    }
                ]
            }
        ]
    },
    unpaidBillsResponse : {

    },
    allPlanDetailsResponse : {

    }
}

const UnpaidBillsReducer = (state: any = initUnpaidBills, action: any) => {
    const { type } = action;
    const { payload } = action;
    var UnpaidValue = {...state.requestBody.steps};

    switch (type) {
        case UnpaidBillsAction.FETCH_UNPAID_BILLS_SUCCESS:
            return {...state, unpaidBillsResponse : payload };

        case UnpaidBillsAction.GET_PLAN_DETAILS_SUCCESS:
            return {...state, allPlanDetailsResponse: payload}

        case UnpaidBillsAction.UNPAID_BILLS_ACCEPTED:
            UnpaidValue[0].offerContainerId = payload.offerContainerId;
            UnpaidValue[0].fields[0].value = payload.unpaidBillResponse.TotalAmountDue ? payload.unpaidBillResponse.TotalAmountDue : 0;
            UnpaidValue[0].fields[1].value = JSON.stringify(payload.unpaidBillResponse);
            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, unpaidBillsResponse: {}, allPlanDetailsResponse: {} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'UnpaidBills')
            });
            if(section.length > 0) {
                UnpaidValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < UnpaidValue[0].fields.length; i++) {
                    const UnpaidValueField = section[0].steps[0].fields.filter((field: any) => { return (field.name === UnpaidValue[0].fields[i].name) })[0];
                    UnpaidValue[0].fields[i].value = UnpaidValueField ? UnpaidValueField.value : "";
               }
            }
            return state;

        default:
            return state;
    }
};

export default UnpaidBillsReducer;